import React from 'react';
import { ModuleId } from '../../types';
import { SubSkillHint } from '../../support/hints';
import { VisualAidFactory } from '../../visuals';
import { LatexRenderer } from '../ui/LatexRenderer';
import { AlertCircle } from 'lucide-react';
import { FAMILY_SUPPORT_REGISTRY, getHintsForFamilyId } from '../../support/familySupportRegistry';
interface SubSkillCheatSheetProps {
  moduleId: ModuleId;
  subSkill?: string;
  familyId?: string;
}
export function SubSkillCheatSheet({
  moduleId,
  subSkill,
  familyId
}: SubSkillCheatSheetProps) {
  const familySupport = familyId ? FAMILY_SUPPORT_REGISTRY[familyId] : null;
  const hints = familyId ? getHintsForFamilyId(familyId) : null;
  if (!familySupport || !hints || hints.length === 0) {
    return <div className="text-center p-8 bg-slate-50 rounded-xl border border-slate-100" data-id="element-5082">
        <AlertCircle className="w-10 h-10 mx-auto mb-3 text-slate-300" data-id="element-5083" />
        <p className="text-slate-500 font-medium" data-id="element-5084">
          Geen spiekbriefje beschikbaar voor dit onderwerp.
        </p>
        {!familyId && <p className="text-slate-400 text-sm mt-2" data-id="element-5085">
            Geen familyId beschikbaar voor deze vraag.
          </p>}
      </div>;
  }
  const renderHintSection = (hint: SubSkillHint) => <div key={hint.id} className="mb-8 last:mb-0 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-5086">
      <div className="mb-4 border-b border-slate-100 pb-2" data-id="element-5087">
        <h3 className="text-xl font-bold text-slate-900" data-id="element-5088">{hint.title}</h3>
        {hint.description && <p className="text-slate-600 text-sm mt-1" data-id="element-5089">{hint.description}</p>}
      </div>

      <div className="space-y-4" data-id="element-5090">
        {hint.steps.map((step, index) => <div key={index} className="group" data-id="element-5091">
            <div className="bg-white rounded-xl p-4 border border-slate-200 shadow-sm hover:border-indigo-200 transition-colors" data-id="element-5092">
              <div className="flex gap-3" data-id="element-5093">
                {/* Compact Step Indicator */}
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center text-xs font-bold mt-0.5" data-id="element-5094">
                  {index + 1}
                </div>

                <div className="flex-1" data-id="element-5095">
                  {step.title && <h4 className="font-bold text-slate-800 mb-1 text-base" data-id="element-5096">
                      {step.title}
                    </h4>}

                  <div className="text-slate-700 text-sm leading-relaxed whitespace-pre-line" data-id="element-5097">
                    <LatexRenderer content={step.content} data-id="element-5098" />
                  </div>

                  {step.visual && <div className="mt-4 bg-slate-50 rounded-lg p-3 border border-slate-100" data-id="element-5099">
                      <VisualAidFactory visualAid={{
                  type: step.visual.type,
                  data: step.visual.data,
                  showWhen: 'always'
                }} data-id="element-5100" />
                    </div>}
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
  const familyHint: SubSkillHint = {
    id: familySupport.familyId,
    title: 'Uitleg & Tips',
    description: familySupport.defaultExplanation,
    steps: hints
  };
  return <div className="space-y-6" data-id="element-5101">{renderHintSection(familyHint)}</div>;
}